<template>
  <v-app id="inspire">
    <template v-if="!$route.meta.allowAnonymous">
        <v-content>
          <router-view></router-view>
        </v-content>
    </template>
    <template v-else>
        <navigation :toggle="drawer"/>
        <toolbar @toggleNavigationBar="drawer = !drawer" :name="$route.meta.name" />
        <v-content>
           <router-view/>
        </v-content>
          <v-footer class="indigo darken-1" app >
            <span class="white--text">&copy; {{ year() }}</span>
          </v-footer>
    </template>
    <MainFormDialog v-if="get_dialogMain.dialog" />
    <MainAlertDialog v-if="get_alertMain.alert" />
  </v-app>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import MainFormDialog from '@/components/dialog/main/MainFormDialog'
import MainAlertDialog from '@/components/dialog/MainAlertDialog'
export default {
  name: 'App',
  data: () => ({
    drawer: false
  }),
  components: {
    MainFormDialog,
    MainAlertDialog
  },
  beforeMount () {
  },
  methods: {
    ...mapActions(['getUrlServices']),
    ...mapMutations(['SHOW_DIALOG_MAIN']),
    year () {
      const year = new Date().toISOString().substr(0, 4)
      return year
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_alertMain'])
  },
  watch: {}
}
</script>
